"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CheckBox = void 0;

var _react = _interopRequireDefault(require("react"));

var _CheckBox = _interopRequireDefault(require("@mui/icons-material/CheckBox"));

var _styles = require("./styles");

var _jsxRuntime = require("react/jsx-runtime");

var CheckBox = function CheckBox(_ref) {
  var id = _ref.id,
      label = _ref.label,
      onChange = _ref.onChange,
      isFilter = _ref.isFilter,
      defaultChecked = _ref.defaultChecked,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      checked = _ref.checked,
      typeColor = _ref.typeColor,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Container, {
    className: className,
    typeColor: typeColor,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
      type: "checkbox",
      name: id,
      id: id,
      onChange: onChange,
      defaultChecked: defaultChecked,
      disabled: disabled,
      checked: checked
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("label", {
      htmlFor: id,
      children: label && /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
        className: isFilter && "filter-text",
        children: label
      })
    })]
  }, "check-".concat(id));
};

exports.CheckBox = CheckBox;